/** Traduz o registro técnico sem depender de parâmetros ou dados do usuário. */
const TELAS: Record<string, string> = {
  produto: 'Produtos', produtos: 'Produtos', 'editar-venda': 'Pedidos de venda',
  pedidos: 'Pedidos de venda', demonstrativo: 'Demonstrativo de vendas',
  cotacoes: 'Cotações', estoque: 'Estoque', separacao: 'Separação',
  conferencia: 'Conferência', logistica: 'Logística',
  'pendencia-separacao': 'Pendências de separação',
  'pendencia-conferencia': 'Pendências de conferência',
  'pendencia-vendedor': 'Pendências do vendedor',
  'controle-acessos': 'Controle de acessos', 'controle-acesso': 'Controle de acessos',
  'atividade-acessos': 'Atividade de acessos', 'usuario-logado': 'Dados do usuário',
  parceiro: 'Parceiros', parceiros: 'Parceiros', clientes: 'Clientes',
  aeronaves: 'Aeronaves', prefixos: 'Prefixos', fabricante: 'Fabricantes',
  serial: 'Seriais', lote: 'Lotes', volume: 'Volumes',
  'regras-comissao': 'Regras de comissão', config: 'Configurações',
  traducao: 'Tradução', receitaws: 'Consulta de CNPJ',
  'uploadAnexo.mge': 'Anexos', mge: 'Anexos',
  'cancelar-movimento': 'Movimentações', 'confirmar-movimento': 'Movimentações',
  'alterar-top-movimento': 'Movimentações', proxy: 'Integração Sankhya',
  services: 'Integração Sankhya'
};

const VERBOS: Record<string, string> = {
  salvar: 'Salvar', gravar: 'Salvar', editar: 'Editar', alterar: 'Editar',
  atualizar: 'Editar', buscar: 'Buscar', busca: 'Buscar', pesquisar: 'Buscar',
  consultar: 'Buscar', carregar: 'Buscar', listar: 'Buscar',
  deletar: 'Excluir', excluir: 'Excluir', remover: 'Remover',
  finalizar: 'Finalizar', confirmar: 'Confirmar', cancelar: 'Cancelar',
  estornar: 'Estornar', iniciar: 'Iniciar', continuar: 'Continuar',
  transferir: 'Transferir', dividir: 'Dividir', duplicar: 'Duplicar',
  copiar: 'Copiar', importar: 'Importar', exportar: 'Exportar',
  calcular: 'Calcular', executar: 'Executar', processar: 'Processar',
  atribuir: 'Atribuir', registrar: 'Registrar', sinalizar: 'Sinalizar pendência',
  resolver: 'Resolver pendência', desfazer: 'Desfazer', enviar: 'Enviar',
  download: 'Baixar arquivo', preview: 'Visualizar prévia'
};

export function descreverAcao(registro: string): string {
  if (registro === 'Login realizado') return 'Acesso ao sistema — Entrar';
  if (registro === 'Sessão encerrada') return 'Acesso ao sistema — Sair';
  const match = /^(GET|POST|PUT|PATCH|DELETE|HEAD|OPTIONS)\s+\/api\/sankhya\/([^?\s]+)/.exec(registro);
  if (!match) return registro;
  const [, metodo, caminho] = match;
  const partes = caminho.split('/').filter(p => p && !p.startsWith('{'));
  const modulo = partes[0];
  const tela = TELAS[modulo] ?? 'Sistema';
  const operacao = partes.slice(1);
  // O último verbo tem precedência: ajustes/carregar é busca, ajustes/salvar é gravação.
  let acao = operacao.map(p => VERBOS[p.split('-')[0].replace('.mge', '')]).filter(Boolean).pop();
  if (!acao && operacao.length === 0) acao = VERBOS[modulo.split('-')[0]];
  if (!acao && metodo === 'DELETE') acao = 'Excluir';
  if (!acao && (metodo === 'PUT' || metodo === 'PATCH')) acao = 'Editar';
  if (!acao && modulo === 'editar-venda') acao = 'Editar';
  if (!acao && modulo === 'produto' && operacao.join('/') === 'tipo-controle') acao = 'Editar tipo de controle';
  if (!acao && modulo === 'produto' && operacao.includes('alternativos') && metodo === 'POST') acao = 'Salvar produto alternativo';
  if (!acao && modulo === 'cotacoes' && operacao.length === 0 && metodo === 'POST') acao = 'Salvar';
  if (!acao && modulo === 'uploadAnexo.mge') acao = 'Enviar arquivo';
  if (!acao && modulo === 'traducao') acao = 'Traduzir';
  // Várias consultas usam POST; o método sozinho não significa salvar.
  if (!acao) acao = modulo === 'proxy' || modulo === 'services' || !TELAS[modulo]
    ? 'Executar ação' : 'Buscar';
  return `${tela} — ${acao}`;
}
